import { IPricingData } from '../types';

export const pricingData: IPricingData = {
  header: {
    title: '리얼월드 스튜디오 요금제',
    subtitle: '개인 크리에이터부터 학교, 기업까지\n인터랙티브 콘텐츠 제작을 위한 맞춤형 플랜'
  },
  plans: [
    {
      id: 'free',
      name: '무료',
      price: {
        monthly: 0,
        yearly: 0
      },
      period: '채널당/월',
      description: '가볍게 시작해보는',
      features: [
        { text: '최초 100 AI 크레딧', included: false, isGradient: true },
        { text: '콘텐츠 3개 제작 ', included: true },
        { text: '기본 콘텐츠 템플릿', included: true },
        { text: '기본 상호작용, 실감기술 도구', included: true },
        { text: '콘텐츠 플레이 수 데이터', included: true }
      ],
      cta: {
        text: '무료로 시작하기',
        variant: 'secondary'
      }
    },
    {
      id: 'pro',
      name: '프로',
      badge: '추천 요금제',
      price: {
        monthly: 14900,
        yearly: 149000
      },
      period: '채널당/월',
      description: '전문 크리에이터를 위한',
      discount: {
        yearly: 16
      },
      features: [
        { text: '무료의 모든 기능 +', included: true, highlight: true },
        { text: '월 500 AI 크레딧', included: false, isGradient: true },
        { text: '콘텐츠 10개 제작', included: true },
        { text: '고급 템플릿', included: true },
        { text: '모든 상호작용, 실감기술 도구', included: true },
        { text: '미션별 완료율 데이터', included: true },
        { text: '후원받기 기능', included: true },
        { text: '테스터 3명 초대', included: true }
      ],
      cta: {
        text: '구독하기',
        variant: 'primary'
      },
      highlighted: true
    },
    {
      id: 'enterprise',
      name: '엔터프라이즈',
      price: {
        monthly: null,
        yearly: null
      },
      period: '',
      description: '광고, 앱 설치 NO! 행사 운영 효율을 높인',
      features: [
        { text: '프로의 모든 기능 +', included: true, highlight: true },
        { text: '월 10,000 AI 크레딧', included: false, isGradient: true },
        { text: '콘텐츠 무제한 제작', included: true },
        { text: '플레이 시간 데이터', included: true },
        { text: '앱 설치 없이 모바일 웹플레이 가능', included: true },
        { text: '콘텐츠 시작, 하단 광고 제거', included: true },
        { text: '채널 소유자, 편집자, 테스터 초대', included: true }
      ],
      cta: {
        text: '맞춤 견적 받기',
        variant: 'primary'
      }
    },
    {
      id: 'class',
      name: '티처, 클래스',
      price: {
        monthly: null,
        yearly: null
      },
      period: '',
      description: '창의 학습, 수업에 적용하기 좋은',
      features: [
        { text: '교육 특화 기능 추가 ', suffix: '(클래스 기준)', included: true, highlight: true },
        { text: '월 10,000 AI 크레딧', included: false, isGradient: true },
        { text: '콘텐츠 무제한 제작', included: true },
        { text: '교육 맞춤형 템플릿 추가 제공', included: true },
        { text: 'LMS 활용 가능 데이터', included: true },
        { text: '앱 설치 없이 모바일 웹플레이 가능', included: true },
        { text: '콘텐츠 시작, 하단 광고 제거', included: true },
        { text: '채널 소유자, 편집자, 테스터 초대', included: true }
      ],
      cta: {
        text: '더 알아보기',
        variant: 'primary'
      }
    }
  ],
  faq: {
    title: '궁금한 점이 있으신가요?',
    items: [
      {
        id: 'faq-1',
        question: '리얼월드 스튜디오는 무료로 사용할 수 있나요?',
        answer:
          '네 리얼월드 스튜디오는 기본적으로 무료로 이용할 수 있습니다. \n무료 요금제에서도 ‘최대 3개’의 콘텐츠를 만들고 배포할 수 있으나 \n더 많은 기능과 AI 크레딧을 이용하고 싶으시다면 유료 요금제 가입이 필요합니다.'
      },
      {
        id: 'faq-2',
        question: '어떤 요금제를 선택해야 할지 모르겠어요.',
        answer:
          '리얼월드 스튜디오는 누구나 쉽게 인터랙티브 콘텐츠를 만들 수 있는 저작 툴입니다. \n\n‘무료 요금제’는 가볍게 리얼월드 스튜디오를 체험해보고 싶은 분들에게 적합합니다. \n더 많은 기능을 활용하여 다양한 콘텐츠를 만들고, 후원을 통한 수익까지 내보고 싶다면 ‘프로 요금제’를 추천드립니다. \n‘엔터프라이즈 요금제’는 팀 단위 콘텐츠 제작이 필요한 경우나 캠페인 또는 행사, 이벤트 운영용 콘텐츠 제작에 적합합니다. \n‘클래스 요금제’는 학교나 교실에서 교육 기관 전용으로 교육용 템플릿이 제공되며, 학생들과 함께 콘텐츠를 만들거나 LMS 데이터를 볼 수 있는 등 수업에 활용할 수 있는 추가 기능을 제공합니다. \n\n리얼월드 스튜디오가 처음이라면, 무료로 시작해보고 필요에 따라 업그레이드를 권장드립니다.'
      },
      {
        id: 'faq-3',
        question: '요금제는 어떻게 업그레이드 하나요?',
        answer:
          '프로 요금제는 구독형으로 월/연간 카드 결제 방식으로 진행됩니다. 엔터프라이즈와 클래스 요금제는 원하는 개월 수 만큼 선결제 후적용 방식입니다. 엔터프라이즈는 도입 문의를 통해 신청할 수 있으며, 클래스 요금제는 {리얼월드 스쿨 웹사이트}에서 결제할 수 있습니다. \n\n프로 요금제 이용 중 엔터프라이즈나 클래스 요금제로 변경을 원하실 경우, 프로 요금제 구독 해지 후 유지 기간이 끝난 뒤에 다른 요금제로의 변경이 가능합니다.'
      },
      {
        id: 'faq-4',
        question: '요금제 사용 기간이 종료되면 제작된 콘텐츠는 어떻게 되나요?',
        answer:
          '유료 요금제 사용 기간이 종료되거나 무료 요금제로 전환되어도 기존 콘텐츠는 삭제되지 않습니다. \n다만 무료 요금제에서 지원하는 최대 콘텐츠 개수 3개를 초과한 경우, 모든 콘텐츠는 ‘보기 전용’으로 전환되어 편집이 제한됩니다. 콘텐츠 삭제하기를 통해 콘텐츠 개수가 3개 이내가 되면 모든 콘텐츠의 편집이 가능합니다.'
      },
      {
        id: 'faq-5',
        question: '해지 / 환불 정책은 어떻게 되나요?',
        answer:
          '프로 요금제는 구독 해지를 통해 언제든 취소할 수 있으며, 해지는 \n다음 결제일(갱신일)부터 적용됩니다. \n엔터프라이즈, 클래스 요금제는 적용 후 7일 이내 전액 환불됩니다. \n적용 후 7일이 지나는 경우 환불이 어려우니 유의 바랍니다. \n요금제 취소나 환불이 필요하신 경우 프로필 > 문의하기 > 채널톡을 통해 문의를 부탁드리며, 보다 더 자세한 내용은 {환불 정책}에서 확인하실 수 있습니다.'
      },
      {
        id: 'faq-6',
        question: '리얼월드 스쿨과는 뭐가 다른가요?',
        answer:
          '리얼월드 스쿨은 현직 교사가 학교 교실 안에서 수업용으로만 쓰도록 한정된 서비스입니다.\n이 범위를 벗어나 이용하면 사전 공지 없이 콘텐츠가 미공개 처리될 수 있습니다.\n\n학교 수업에 쓰실 예정이라면 {리얼월드 스쿨 웹사이트}에서 요금제를 확인해 주세요.'
      }
    ]
  },
  cta: {
    title: '기업 또는 학교에서 도입을 검토하고 계신가요?',
    subtitle: '문의를 남겨주시면 빠르게 연락드릴게요!',
    buttons: [
      {
        text: '엔터프라이즈 요금제 도입 문의',
        variant: 'primary',
        action: '/contact'
      },
      {
        text: '클래스 요금제 구입',
        variant: 'secondary',
        action: 'https://realworld-school.org/'
      }
    ]
  },
  comparison: {
    sections: [
      {
        title: '콘텐츠 생성',
        rows: [
          { feature: '콘텐츠 삭제', free: true, pro: true, enterprise: true, class: true },
          {
            feature: '콘텐츠 생성 개수 제한',
            free: '3개',
            pro: '10개',
            enterprise: '무제한',
            class: '무제한'
          },
          {
            feature: '템플릿',
            free: '무료 템플릿',
            pro: '+ 고급 템플릿',
            enterprise: '+ 고급 템플릿',
            class: '+ 전용 템플릿'
          },
          {
            feature: 'AI 크레딧',
            free: '최초 100 크레딧',
            pro: '월 500 크레딧',
            enterprise: '월 10,000 크레딧',
            class: '월 10,000 크레딧'
          },
          { feature: 'AI로 콘텐츠 생성', free: true, pro: true, enterprise: true, class: true }
        ]
      },
      {
        title: '콘텐츠 편집',
        rows: [
          {
            feature:
              '기본 상호 작용 기능\n• 텍스트 입력\n• 버튼 클릭\n• 방향 입력\n• 4자리 비밀번호 입력\n• 웹뷰 페이지 활용',
            free: true,
            pro: true,
            enterprise: true,
            class: true
          },
          { feature: '아이템', free: '30개 제한', pro: true, enterprise: true, class: true },
          { feature: '챗봇', free: true, pro: true, enterprise: true, class: true },
          {
            feature:
              '카메라 기반 실감 기능\n• 프레임 촬영\n• QR 인식\n• AR\n• 컬러 필터 렌즈\n• 이미지 오버랩',
            free: false,
            pro: true,
            enterprise: true,
            class: true
          },
          {
            feature: '위치 기반\n상호작용 기능 (GPS)',
            free: false,
            pro: true,
            enterprise: true,
            class: true
          },
          {
            feature: '디바이스 연동 도구\n(NFC 태그 인식)',
            free: false,
            pro: true,
            enterprise: true,
            class: true
          },
          { feature: 'AI 이미지 생성', free: true, pro: true, enterprise: true, class: true },
          { feature: 'AI BGM 생성', free: true, pro: true, enterprise: true, class: true }
        ]
      },
      {
        title: '플레이 환경',
        rows: [
          { feature: '후원받기', free: false, pro: true, enterprise: true, class: false },
          {
            feature: '콘텐츠 시작 광고 제거',
            free: false,
            pro: false,
            enterprise: true,
            class: true
          },
          {
            feature: '콘텐츠 하단 광고 제거',
            free: false,
            pro: false,
            enterprise: true,
            class: true
          },
          { feature: '웹 플레이', free: false, pro: false, enterprise: true, class: true },
          {
            feature: '콘텐츠 판매 및 수익화',
            free: false,
            pro: false,
            enterprise: false,
            class: true
          }
        ]
      },
      {
        title: '데이터 대시보드',
        rows: [
          {
            feature: '데이터 조회',
            free: '최근 7일',
            pro: '최근 30일',
            enterprise: '최근 365일',
            class: '최근 365일'
          },
          { feature: '플레이 수', free: true, pro: true, enterprise: true, class: true },
          { feature: '미션별 완료율', free: false, pro: true, enterprise: true, class: true },
          { feature: '플레이 시간', free: false, pro: false, enterprise: true, class: true },
          { feature: '데이터 다운로드', free: false, pro: true, enterprise: true, class: true }
        ]
      },
      {
        title: '채널 설정',
        rows: [
          {
            feature: '편집자 초대',
            free: false,
            pro: false,
            enterprise: '최대 25명',
            class: '최대 25명'
          },
          {
            feature: '소유자 초대',
            free: false,
            pro: ' ',
            enterprise: '최대 3명',
            class: '최대 3명'
          },
          {
            feature: '테스터 초대',
            free: false,
            pro: '최대 3명',
            enterprise: '무제한',
            class: '무제한'
          },
          { feature: '동시 접속', free: false, pro: false, enterprise: true, class: true }
        ]
      }
    ]
  }
};
